import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { eventBus } from "../../services/eventHandler";
import { useClock } from "../../services/ClockProvider";

const Clock = () => {
  const { getMoment,clockDiff,getMomentDiff } = useClock();
  const [timeOfDay, setTimeOfDay] = useState("..:,,:..");
  const [timediff, setTimediff] = useState<number>(0);
  const diffTime = useRef<number>(0);
  useEffect(() => {
    const handler = (diffTime: number) => {
      // setAthletes(ath);+
      setTimediff(diffTime);
    };
    const intervalId = setInterval(() => {
      let tim = getMomentDiff(diffTime.current).format("HH:mm:ss");
      setTimeOfDay(tim);
    }, 250);

    eventBus.on(`time_diff`, handler);
    return () => {
      // Cleanup to avoid memory leaks
      eventBus.removeListener(`time_diff`, handler);
      clearInterval(intervalId);
    };
  }, []);
  useEffect(() => {
      diffTime.current = clockDiff;
  },[clockDiff])

  return <>{timeOfDay}</>;
};

export default Clock;
